// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__umlI0","col":"styles_col__1xbtm"};